










import { Component, Vue } from 'vue-property-decorator'

import 'devextreme-intl'
import { loadMessages, locale } from 'devextreme/localization';
import messagesRu from 'devextreme/localization/messages/ru.json';
import ConnectionLostPopup from "@/components/ConnectionLost/connection-lost-popup.vue";
import AnimatePopup from '@/components/AnimatePopup/animate-popup.vue';
import { AppModule } from '@/store/modules/app';
import NotifyService from '@/services/notify_service';
import request from "@/utils/request";

import DictsCacheService from '@/services/dicts_cache_service';
import PresetService from '@/services/user_preset_service';
import EcoObjectsService from '@/services/eco-objects-service';
import {AxiosResponse} from "axios";
import UserAccessService from '@/services/user_access_service';
import UserManagerService from '@/services/data/user_manager';
import YearService from "@/services/years-service";
import WebSocketService from "@/services/websocket_service";
import ShareService from "@/services/share-service";
import * as _ from "lodash";
import ContractorService from "@/services/contractor-service";
import TariffService from "@/services/tariff-service";
import { Contractor } from './services/models-service';
import CutService from '@/services/cut-service'
import MonitoringService from "@/views/admin/monitoring/service";
import AuthService, { AuthCheck } from "@/services/auth_service";
import Imbalance_service from "@/services/imbalance_service";


@Component({
  name: 'App',
  components: {
    ConnectionLostPopup,
    AnimatePopup
  }
})
export default class extends Vue {
  private notify = NotifyService;

  get isAdAuth() {
    return AuthService.isActiveDirectoryAuth();
  }

  async created() {
    loadMessages(messagesRu);
    loadMessages({'ru': {"dxForm-requiredMessage": "Обязательное поле: {0}"}});
    locale('ru');

    this.pingServer();

    // Для Chrome требуется немного времени, чтобы router-view "прогрелся" и текущий роут отображался правильно,
    // что важно для работы интерцепторов (напр. axios)
    ShareService.initializing = true;
    if (!this.isAdAuth) {
      setTimeout(() => {
        this.updateCache().finally(() => {
          ShareService.initializing = false;
        });
      }, 200);
    }

    this.subscribeSocketMessages();

    try {
      await Imbalance_service.getImbalanceColors();
    } catch (e) {
      console.error('Ошибка при загрузке цветов дисбаланса:', e);
    }
  }

  private subscribeSocketMessages() {
    if (this.$options.sockets) {
      this.$options.sockets.onmessage = (data: any) => {

        let res = WebSocketService.handleMsg(data, 'cuts_update');
        if (!_.isNil(res)) {
          DictsCacheService.loadCuts()
        }

        res = WebSocketService.handleMsg(data, 'update_accept');
        if (!_.isNil(res)) {
          CutService.SetCutAcceptChanges(res)
        }

        res = WebSocketService.handleMsg(data, 'update_contractor');
        if (!_.isNil(res)) {
          if (res.mode === "change") {
            if (res.post) {
              const id_cut = res.post.id_cut;
              if (ContractorService.cachedContractors.hasOwnProperty(id_cut)) {
                ContractorService.cachedContractors[id_cut].push(res.post);
              }
            }
            if (res.put) {
              const id_cut = res.put.id_cut;
              if (ContractorService.cachedContractors.hasOwnProperty(id_cut)) {
                const index = ContractorService.cachedContractors[id_cut].findIndex((c: Contractor) => c.id === res.put.id);
                if (index) ContractorService.cachedContractors[id_cut][index] = res.put;
              }
            }
          }

          if (res.mode === "delete" && res.delete) {
            for (let cut in ContractorService.cachedContractors) {
              ContractorService.cachedContractors[cut] = ContractorService.cachedContractors[cut].filter((c: Contractor) => c.id !== res.delete)
            }
          }
        }

        res = WebSocketService.handleMsg(data, 'update_tariff');
        if (!_.isNil(res)) {
          TariffService.preloadedTariffsEcoNodeId = null;
        }

        res = WebSocketService.handleMsg(data, 'user_role_update');
        // Подписка на изменение роли или списка тепловых узлов пользователя
        if (!_.isNil(res)) {
          if (AuthService.getUserId() === res.user_id) {
            if (res.role && res.role !== AuthService.getRole()) {
              AuthService.resetToken();
              this.notify.info("Изменена роль текущего пользователя. Пожалуйста, перезагрузите страницу", true, 20000);
            } else if (!AuthService.isAdmin() && res.heat_node_ids) {
              AuthService.resetToken();
              this.notify.info("Изменены параметры доступа к тепловым узлам для текущего оператора. Пожалуйста, перезагрузите страницу", true, 20000);

            }
          }
        }

      }
    }
  }

  private destroyed(): void {
    if (this.$options.sockets) {
      delete this.$options.sockets.onmessage;
    }
  }

  async updateCache() {
    // Первым должен стоять одиночный запрос к БД, а не c Promiose.all,
    // иначе в режиме AD с сгоревшим токеном будет несколько раз срабатывать триггер перезапроса данных active Directory
    await MonitoringService.getGatewayStatus();
    YearService.loadLocalStorageData();
    if (YearService.YearList.length === 0) {
      await YearService.loadFromDb();
    }
    await DictsCacheService.update_dicts_cache();
    await UserAccessService.load_cache();
    await UserManagerService.getCurrentUser();
    await PresetService.load_cache();
    EcoObjectsService.update_cache();
  }

  async getDbSchema() {
    return request({
      url: '/meta',
      method: 'get'
    }).then(resp => {
      AppModule.SetDbSchema(resp.data)
    });
  }

  public get backupAnimatePopupOptions() {
    return {
      visible: AppModule.isDbRestore,
      text: 'Идёт восстановление базы данных из резервной копии...'
    }
  }

  public get adLoginPopupOptions() {
    return {
      visible: AppModule.fetchActiveDirectoryLogin,
      text: 'Идёт проверка пользователя Active Directory...'
    }
  }

  protected mounted(): void {

  }

  async pingServer() {
    setTimeout(() => {
      this.pingServer();
    }, 5000);

    if (!AppModule.isConnected || AppModule.fetchActiveDirectoryLogin) {
      return
    }

    try {
      const resp: AxiosResponse["data"] = await request({
        url: `/ping`,
        method: 'get',
      });

    } catch (e) {
      AppModule.SetConnectionState(false)
    }

  }
}
